import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Error, Flex, Modal, Typography } from 'shared/_ui';
import { CONTROL_IDS, REF_IDS } from 'shared/consts';
import { useStoreUiControls } from 'shared/lib';
import styles from './styles.module.scss';
import { useRefContext } from 'shared/context';
import { sendAnalyticsEvent } from 'shared/lib/analytics';

const FreeConnectionModal : React.FC = () => {
    const { t } = useTranslation();

    const [isMounted, setIsMounted] = React.useState<boolean>(false);
  
    const { isOpen, close } = useStoreUiControls(
      CONTROL_IDS.FREE_CONNECTION_MODAL
    );
  
    const { open: openTariffs } = useStoreUiControls(CONTROL_IDS.AVAILABLE_PLANS);
    const { refs } = useRefContext();
  
    const scrollToTariffList = () => {
      const layoutRef = refs.current[REF_IDS.LAYOUT];
      const availablePlansRef = refs.current[REF_IDS.AVAILABLE_PLANS];
  
      if (layoutRef && availablePlansRef) {
        const scrollOffset = 32;
  
        const elementPosition =
          availablePlansRef.getBoundingClientRect().top + layoutRef.scrollTop;
        const offsetPosition = elementPosition - scrollOffset;
  
        layoutRef.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    };
  
    const onClick = () => {
      sendAnalyticsEvent('click_cta', { location: 'onboarding_modal' });
      close();
      openTariffs();
      scrollToTariffList();
    };
  
    React.useEffect(() => {
      if (!isOpen) {
        const timer = setTimeout(() => {
          setIsMounted(false);
        }, 300);
  
        return () => clearTimeout(timer);
      } else {
        setIsMounted(true);
      }
    }, [isOpen]);
  
    if (!isMounted) return null;

    return (
        <Modal isOpen={isOpen} onClose={close}>
          <Flex
            className={styles.container}
            direction="column"
            spacing={32}
            align="center"
          >
            <Error className={styles.error}/>
            <Flex direction="column" spacing={24}>
              <Typography.Title level={1}>
                {t('banner.freeConnection.title')}
              </Typography.Title>
              <Flex direction="column" spacing={8}>
                <Typography.Text size={3}>
                    {t('banner.freeConnection.subtitle')}
                    <span className={styles.free}></span>
                </Typography.Text>
              </Flex>
            </Flex>
            <Button className={styles.button} onClick={onClick} type="primary">
              {t('banner.freeConnection.button')}
            </Button>
          </Flex>
        </Modal>)
}
export {FreeConnectionModal};
